import React from "react";
import "./terminal-row.css";
import StatusBadge from "components/status-badge/StatusBadge";
import type { StatusVariant } from "utils/merchant";
import { posTypeName, posVendorName } from "utils/pos";

export interface TerminalRecord {
  serialId: string;
  serial: string;
  status: StatusVariant;
  vendorDigit: number;
  typeDigit: number;
}

function TerminalRow({
  serial,
  status,
  vendorDigit,
  typeDigit,
}: TerminalRecord) {
  return (
    <div className="tm-row">
      <span className="tm-serial">{serial}</span>
      <span className="tm-type">{posTypeName(typeDigit)}</span>
      <span className="tm-vendor">{posVendorName(vendorDigit)}</span>
      <span className="tm-status">
        <StatusBadge status={status} />
      </span>
    </div>
  );
}

export default TerminalRow;
